module.exports = __webpack_public_path__ + "static/img/icon_shape_your_life.6c68cef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_shape_your_life.svg
// module id = pNTS
// module chunks = 1